import { Box, Typography, Grid, CircularProgress, Divider, Card, DialogActions, Button, CardContent, TableHead } from '@mui/material';
import axios from 'axios';
import React, { useState, useEffect, useRef } from "react";
import { GET_IMPORT_INVOICE, READ_PURCHASE_ORDER } from '../../../services/apiRoutes';
import DetailsParticulars from '../../common/DetailsPage/DetailsParticulars';
import CustomCardView from '../../common/CustomCardView';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { convertNumberToWords, printFunction } from '../../../services/apiServices';
import CustomPrintModel from '../../common/CustomPrint';
import { PurchaseOrderFirst, PurchaseOrderFour, PurchaseOrderSecond, PurchaseOrderThird } from '../PrintPdf/PurchaseOrderPrint';
import { genericPost } from '../../../services/authServices';
import { getRoundAmount } from '../../../services/CommonServices';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import { t } from '../../../constants/translationHelper';



const PurchaseOrderView = ({ handleClose, purchaseOrderId, shipmentOrgId, templateId, productsList, purchasePrefix, purchaseSuffix }) => {
    const companyDateFormat = useCompanyDateFormat();

    const [data, setData] = useState(null);
    const [dataParticular, setDataParticular] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [totalQty, setTotalQty] = useState(0); // State for total quantity
    const [totalAmount, setTotalAmount] = useState(0); // State for total rate
    const [amountData, setAmount] = useState(0);
    const [termConditions, setTermConditions] = useState([]);
    const [companyBanks, setCompanyBanks] = useState([]);
    const [shipments, setShipments] = useState([]);
    const [shippingBooking, setShippingBooking] = useState([]);
    const [paymentVoucher, setPaymentVoucher] = useState([]);
    const [companyTaxes, setCompanyTaxes] = useState([]);
    const [shippingmark, setShippingmark] = useState([]);
    const [amountText, setAmountText] = useState(0);
    const [currencyName, setCurrencyName] = useState('');

    const number = amountText || '';
    const amountInWords = convertNumberToWords(number);

    useEffect(() => {
        fetchDataInvoice();
    }, []);

    const fetchDataInvoice = async () => {
        setLoading(true);
        try {
            const payload = { shipmentOrgId: shipmentOrgId };
            const response = await genericPost(GET_IMPORT_INVOICE, payload);
            if (response?.data?.success) {
                const resData = response.data.data;
                setTermConditions(resData.termConditions || []);
                setCompanyBanks(resData.companyBanks || []);
                setShipments(resData.shipments || []);
                setShippingBooking(resData.shippingBooking || []);
                setPaymentVoucher(resData.paymentVoucher || []);
                setCompanyTaxes(resData.companyTaxes || []);
                setShippingmark(resData.shippingmark || []);
            } else {
                setError('No data found');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError('Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!purchaseOrderId) return;

        const fetchData = async () => {
            try {
                const accessToken = sessionStorage.getItem('accessToken');
                const response = await axios.get(READ_PURCHASE_ORDER(purchaseOrderId), {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                if (response.data.success) {
                    const purchaseOrder = response.data.purchaseOrder;
                    const symbol = purchaseOrder?.currency?.currency_symbol || '';
                    const currencyName = purchaseOrder?.currency?.currency_name || '';

                    const particulars = purchaseOrder.particulars.map(particular => ({
                        qty: particular.qty || 0,
                        rate: `${symbol} ${parseFloat(particular.rate).toFixed(2)}`,
                        amount: parseFloat(particular.amount) || 0,
                        amounts: `${symbol} ${parseFloat(particular.amount).toFixed(2)}`,
                        productName: particular.products.productName,
                        unitName: particular.productsUnit.unitName,
                    }));
                    const totalQuantity = particulars
                        .reduce((total, particular) => total + (parseFloat(particular.qty) || 0), 0);
                    const amountTotal = particulars.reduce((acc, item) => acc + item.amount, 0);
                    const roundedAmount = getRoundAmount(amountTotal);

                    setAmount(`${symbol} ${roundedAmount.toFixed(2)}`);
                    setAmountText(roundedAmount);
                    setData(purchaseOrder);
                    setDataParticular(particulars);
                    setTotalQty(totalQuantity);
                    setCurrencyName(currencyName); // ✅ store in state
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [purchaseOrderId]);

    if (loading) return <CircularProgress />;
    if (error) return <p>Error: {error}</p>;

    const particularsColumns = [
        {
            id: 'productName',
            label: 'Particular Name',
            accessor: 'productName',
        },
        {
            id: 'qty',
            label: 'Quantity',
            accessor: 'qty',
            styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'rate',
            label: 'Rate',
            accessor: 'rate',
            styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'unitName',
            label: 'Unit',
            accessor: 'unitName',
            styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'amounts',
            label: 'Amount',
            accessor: 'amounts',
            styleAccessor: {
                textAlign: 'right',
            },
        },

    ];


    const footerData = [
        {
            label: t('Total'),

            footerValue: '',
            style: {
                textAlign: 'right',
            },
            colSpan: 1,

        },
        {
            label: '',
            footerValue: totalQty,
            style: {
                textAlign: 'center',

            },

        },
        {
            label: '',
            footerValue: amountData,
            style: {
                textAlign: 'right',

            },
            colSpan: 3,

        },
    ];

    const labels = [
        { key: 'supplier', label: "Supplier", sm: 12, md: 8, },
        { key: 'purchaseOrderNo', label: "Purchase Order No.", sm: 12, md: 4, },
        { key: 'contact', label: "Contact", sm: 12, md: 4, },
        { key: 'date', label: "Date", sm: 12, md: 4, },
        { key: 'currency', label: "currency", sm: 12, md: 4, },
        { key: 'reference', label: "Reference", sm: 12, md: 12, },

    ];

    const values = {
        supplier: data?.supplier?.clientCompanyName || '',
        reference: data?.reference || '',
        purchaseOrderNo: `${purchasePrefix || ''} ${data?.purchaseOrderNo || ''} ${purchaseSuffix || ''}`,
        date: companyDateFormat(data?.date) || '',
        dueDate: companyDateFormat(data?.dueDate) || '',
        note: data?.note || '',
        currency: data?.currency?.currency || '',
        contact: `${data?.Contacts?.firstName || ''} ${data?.Contacts?.lastName || ''}`

    };
    const clientCompanyName = data?.customer?.clientCompanyName || '';
    const encodedCompanyName = clientCompanyName.replace(/ /g, '').toLowerCase();
    const fileName = `commercial_invoice_${encodedCompanyName}.pdf`;

    const printContent = () => {
        const elementId = 'contentId';
        const iframeId = 'print-iframe';
        printFunction(elementId, iframeId, fileName);
    };
    const pdfContent = () => {
        const elementId = 'contentpdf';
        const iframeId = 'print-iframe';
        printFunction(elementId, iframeId, fileName);
    };

    const invoiceTermConditions = termConditions?.find(
        (item) => item.voucherName === "3"
    )?.termConditions || "";
    // const check = parseInt(templateId);
    const footerFalse = false;
    const footerTrue = true;

    const check = parseInt(templateId);

    const getPrintContent = () => {
        if (check === 1) {
            return (<PurchaseOrderFirst
                purchaseOrderNo={values.purchaseOrderNo}
                totalQty={totalQty}
                amountData={amountData}
                invoiceData={data}
                termConditions={invoiceTermConditions}
                companyBanks={companyBanks}
                shippingBooking={shippingBooking}
                shipments={shipments}
                paymentVoucher={paymentVoucher}
                shippingmark={shippingmark}
                companyTaxes={companyTaxes}
                amountInWords={amountInWords}
                footer={footerFalse} />);
        }
        if (check === 2) {
            return (
                <PurchaseOrderSecond purchaseOrderNo={values.purchaseOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerFalse} />);
        }
        if (check === 3) {
            return (
                <PurchaseOrderThird purchaseOrderNo={values.purchaseOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    shippingmark={shippingmark}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerFalse} />);
        }
        if (check === 4) {
            return (
                <PurchaseOrderFour purchaseOrderNo={values.purchaseOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shippingmark={shippingmark}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerFalse} />);
        }

        return <PurchaseOrderFirst purchaseOrderNo={values.purchaseOrderNo}
            totalQty={totalQty}
            amountData={amountData}
            invoiceData={data}
            termConditions={invoiceTermConditions}
            companyBanks={companyBanks}
            shippingBooking={shippingBooking}
            shipments={shipments}
            paymentVoucher={paymentVoucher}
            companyTaxes={companyTaxes}
            amountInWords={amountInWords}
            footer={footerFalse} />;
    };

    const getPdfContent = () => {
        if (check === 1) {
            return (<PurchaseOrderFirst
                purchaseOrderNo={values.purchaseOrderNo}
                totalQty={totalQty}
                amountData={amountData}
                invoiceData={data}
                termConditions={invoiceTermConditions}
                companyBanks={companyBanks}
                shippingBooking={shippingBooking}
                shipments={shipments}
                paymentVoucher={paymentVoucher}
                companyTaxes={companyTaxes}
                amountInWords={amountInWords}
                footer={footerTrue} />);
        }
        if (check === 2) {
            return (
                <PurchaseOrderSecond purchaseOrderNo={values.purchaseOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerTrue} />);
        }
        if (check === 3) {
            return (
                <PurchaseOrderThird purchaseOrderNo={values.purchaseOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    shippingmark={shippingmark}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerTrue} />);
        }
        if (check === 4) {
            return (
                <PurchaseOrderFour purchaseOrderNo={values.purchaseOrderNo}
                    totalQty={totalQty}
                    amountData={amountData}
                    invoiceData={data}
                    termConditions={invoiceTermConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    shippingmark={shippingmark}
                    companyTaxes={companyTaxes}
                    amountInWords={amountInWords}
                    footer={footerTrue} />);
        }

        return <PurchaseOrderFirst purchaseOrderNo={values.purchaseOrderNo}
            totalQty={totalQty}
            amountData={amountData}
            invoiceData={data}
            termConditions={invoiceTermConditions}
            companyBanks={companyBanks}
            shippingBooking={shippingBooking}
            shipments={shipments}
            paymentVoucher={paymentVoucher}
            companyTaxes={companyTaxes}
            amountInWords={amountInWords}
            footer={footerTrue} />;
    };

    return (
        <>

            <CustomPrintModel contentId="contentId">
                {getPrintContent()}
            </CustomPrintModel >

            <CustomPrintModel contentId="contentpdf">
                {getPdfContent()}
            </CustomPrintModel >

            <Box sx={{ mx: 'auto', mb: 0 }}>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <Typography sx={{ fontWeight: 600 }} style={{ color: "#212529", fontSize: "18px" }}>
                            {t("Purchase Order")}
                        </Typography>

                    </Grid>
                    <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Box>
                            <IconButton aria-label="delete">
                                <DeleteOutlineOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                            </IconButton>
                            <IconButton aria-label="print" onClick={printContent}>
                                <LocalPrintshopOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                            </IconButton>
                            <IconButton aria-label="print" onClick={pdfContent}>
                                <PictureAsPdfOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                            </IconButton>
                            <IconButton aria-label="close" onClick={handleClose} >
                                <CloseIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
                <Divider />

                <Grid container spacing={0} sx={{ px: "0%" }}>
                    <Grid item xs={12} md={12} >
                        <CustomCardView
                            title="Bill To"
                            label={labels}
                            data={values}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Box display="flex" flexDirection="row" alignItems="center">
                            <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                {t("Particulars")}
                            </Typography>
                        </Box>
                        <DetailsParticulars
                            title={'Particulars'}
                            columns={particularsColumns}
                            data={dataParticular}
                            footerData={footerData}
                        />
                    </Grid>

                    <Grid item xs={7}>
                        <br />
                        <Box>
                            <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px" }}>
                                {t("In Words")}
                            </Typography>
                            <Typography style={{ color: "#212529", fontWeight: 400, fontSize: "14px", textTransform: "uppercase" }}>
                                {currencyName} {amountInWords}
                            </Typography>
                        </Box>
                        <Box sx={{ pt: 5 }}>
                            <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px" }}>
                                {t("Note")} :
                            </Typography>
                            <Typography style={{ color: "#212529", fontWeight: 400, fontSize: "14px", textTransform: "capitalize" }}>
                                {values.note}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={5}>
                        <br />
                        <Box display="flex" flexDirection="row" alignItems="center">
                            <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                {t("Summary")}
                            </Typography>
                        </Box>
                        <Card sx={{ padding: 2, display: 'flex', flexDirection: 'column', gap: 1, maxWidth: 400 }} variant="outlined">
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography>{t("Total Quantity")}:</Typography>
                                <Typography>{totalQty}</Typography>
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography>{t("Amount")}:</Typography>
                                <Typography> {amountData}</Typography>
                            </Box>

                            <Divider sx={{ my: 0 }} />

                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography fontWeight="bold">{t("Grand Total")}:</Typography>
                                <Typography fontWeight="bold">  {amountData}</Typography>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box >
        </>
    );
};

export default PurchaseOrderView;

